// src/ApiPanel/components/ApiPanelRequireAuth.jsx
// Guards API Panel routes only. This is intentionally a separate component
// from the main app's <RequireAuth> — the two must never be swapped for
// each other, or the isolation between the two auth systems breaks.
import React from "react";
import { Navigate, useLocation } from "react-router";
import { useApiPanelSession } from "../context/ApiPanelSessionContext";
import { API_PANEL_LOGIN_PATH } from "../constants/apiPanelAuth";

export default function ApiPanelRequireAuth({ children }) {
  const { status } = useApiPanelSession();
  const location = useLocation();

  if (status === "loading") {
    return (
      <div className="apip-fullscreen-loader">
        <div className="apip-spinner" />
      </div>
    );
  }

  if (status !== "authed") {
    return <Navigate to={API_PANEL_LOGIN_PATH} state={{ from: location }} replace />;
  }

  return children;
}
